import React, { useCallback, useReducer } from "react";
import { Text, View, TouchableOpacity, ScrollView, Image } from "react-native";
import { color } from "unikit";

const reducer = (state, _action) => !state;

const useForceUpdate = () => {
  const [, dispatch] = useReducer(reducer, true);

  // Turn dispatch(required_parameter) into dispatch().
  const memoizedDispatch = useCallback((): void => {
    dispatch(null);
  }, [dispatch]);
  return memoizedDispatch;
};

var colors = [
  "#fdf752",
  "#8fc7fa",
  "#98aae7",
  color("#9A9EB2").lighten(0.2).toString(),
  color("#9A9EB2").lighten(0.2).toString(),
  color("#9A9EB2").lighten(0.2).toString(),
];

var heights = [30, 50, 50, 50, 50, 50, 50, 40];

export default ({ value, options, onChange }) => {
  const forceUpdate = useForceUpdate();
  return (
    <ScrollView
      style={{ width: "100%" }}
      contentContainerStyle={{ minWidth: "100%" }}
      horizontal
    >
      <View style={{ flexDirection: "row", minWidth: "100%" }}>
        {options.map((data, index) => {
          return (
            <View
              key={index}
              style={{
                flex: 1,
                minWidth: 150,
                paddingRight: 2,
                height: 400,
              }}
            >
              <TouchableOpacity
                style={{
                  width: "100%",
                  justifyContent: "center",
                  textAlign: "center",
                  height: 150,
                  paddingHorizontal: 15,
                  backgroundColor:
                    value && value[data.name] === true
                      ? color("#9A9EB2").lighten(15).toString()
                      : color("#9A9EB2").lighten(30).toString(),
                }}
                onPress={() => {
                  const newValue = value || {};
                  newValue[data.name] = newValue[data.name] ? false : true;
                  onChange(newValue);
                  forceUpdate();
                }}
              >
                <Text style={[{ fontSize: 14, textAlign: "center" }]}>
                  {data.label}
                </Text>
                <Image
                  style={{
                    width: 50,
                    height: 50,
                    alignSelf: "center",
                    marginTop: 8,
                    marginBottom: 9,
                  }}
                  source={{ uri: `https://api.clouddoku.de${data.image}` }}
                />
                <Text
                  style={{ fontSize: 10, textAlign: "center", maxWidth: 150 }}
                >
                  {data.sublabel}
                </Text>
              </TouchableOpacity>
              {data.options.map((subData, subIndex) => {
                return (
                  <TouchableOpacity
                    key={subIndex}
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: 5,
                      paddingRight: 5,
                      flex: 1,
                      marginTop: 2,
                      backgroundColor:
                        value && value[subData.name] === true
                          ? colors[subIndex]
                          : color(colors[subIndex]).lighten(15).toString(),
                    }}
                    onPress={() => {
                      const newValue = value || {};
                      newValue[subData.name] = newValue[subData.name]
                        ? false
                        : true;
                      onChange(newValue);
                      forceUpdate();
                    }}
                  >
                    <Text
                      style={{
                        ineHeight: 1.4,
                        fontSize: 10,
                        textAlign: "center",
                        maxWidth: 150,
                      }}
                    >
                      {subData.label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          );
        })}
      </View>
    </ScrollView>
  );
};
